/**
 * Sample dashboard content.
 * Replace this module when dashboard APIs are ready.
 * Each dashboard card already has a skeleton state for that wiring.
 */

export type RecentKind = 'stationary' | 'playlist' | 'itinerary' | 'article';

export interface RecentItem {
  id: string;
  name: string;
  kind: RecentKind;
  kindLabel: string;
  ago: string;
  to: string;
}

export interface FeatureCard {
  id: RecentKind;
  title: string;
  text: string;
  count: string;
  to: string;
}

export interface StatCard {
  id: 'coins' | 'devices' | 'sessions' | 'locations';
  value: string;
  label: string;
  to: string;
}

export interface TipCard {
  id: RecentKind;
  title: string;
  text: string;
  to: string;
}

export interface DeviceCard {
  id: string;
  name: string;
  meta: string;
  platform: 'android' | 'mac';
}

export type UsagePeriod = 'month' | 'last';

export interface UsageSnapshot {
  sessions: number;
  distance: string;
  time: string;
  locations: number;
}

export const FEATURE_CARDS: FeatureCard[] = [
  {
    id: 'stationary',
    title: 'Stationary Points',
    text: 'Create fixed mock locations',
    count: '12 points',
    to: '/app/stationary',
  },
  {
    id: 'playlist',
    title: 'Playlists',
    text: 'Save multiple locations and play them',
    count: '2 playlists',
    to: '/app/playlist',
  },
  {
    id: 'itinerary',
    title: 'Itineraries',
    text: 'Create complex routes with timing',
    count: '3 itineraries',
    to: '/app/itinerary',
  },
  {
    id: 'article',
    title: 'Articles',
    text: 'Save and manage useful locations',
    count: '8 articles',
    to: '/app/articles',
  },
];

export const STAT_CARDS: StatCard[] = [
  { id: 'coins', value: '250', label: 'Mock Coins', to: '/app/coin-usage' },
  { id: 'devices', value: '2', label: 'Connected Devices', to: '/app/devices' },
  { id: 'sessions', value: '18', label: 'Total Sessions', to: '/app/joystick' },
  { id: 'locations', value: '42', label: 'Saved Locations', to: '/app/location-history' },
];

export const RECENT_ITEMS: RecentItem[] = [
  {
    id: 'home',
    name: 'Home',
    kind: 'stationary',
    kindLabel: 'Stationary Point',
    ago: '2 hours ago',
    to: '/app/stationary',
  },
  {
    id: 'delhi',
    name: 'Delhi Tour',
    kind: 'playlist',
    kindLabel: 'Playlist',
    ago: '5 hours ago',
    to: '/app/playlist',
  },
  {
    id: 'weekend',
    name: 'Weekend Trip',
    kind: 'itinerary',
    kindLabel: 'Itinerary',
    ago: '1 day ago',
    to: '/app/itinerary',
  },
  {
    id: 'cafes',
    name: 'Best Cafes in Delhi',
    kind: 'article',
    kindLabel: 'Article',
    ago: '2 days ago',
    to: '/app/articles',
  },
  {
    id: 'gym',
    name: 'Gym',
    kind: 'stationary',
    kindLabel: 'Stationary Point',
    ago: '2 days ago',
    to: '/app/stationary',
  },
];

export const COIN_SUMMARY = {
  balance: '250',
  used: '120',
  earned: '30',
};

export const DEVICES: DeviceCard[] = [
  {
    id: 'samsung',
    name: 'Samsung F42',
    meta: 'Last active: 14 Oct 2026, 6:20 PM',
    platform: 'android',
  },
  {
    id: 'macbook',
    name: 'MacBook Pro',
    meta: 'Last active: 14 Oct 2026, 12:10 PM',
    platform: 'mac',
  },
];

export const BACKUP_SUMMARY = {
  provider: 'Google Drive',
  status: 'Connected',
  configured: 'Configured',
  lastBackup: 'Last backup: 14 Oct 2026, 6:10 PM',
};

export const USAGE: Record<UsagePeriod, UsageSnapshot> = {
  month: { sessions: 28, distance: '142 km', time: '12.5 h', locations: 18 },
  last: { sessions: 21, distance: '96 km', time: '8.4 h', locations: 11 },
};

export const TIP_CARDS: TipCard[] = [
  {
    id: 'stationary',
    title: 'How to use Stationary Points',
    text: 'Step by step guide',
    to: '/app/articles',
  },
  {
    id: 'playlist',
    title: 'Create and play Playlists',
    text: 'Learn how to use playlists',
    to: '/app/articles',
  },
  {
    id: 'itinerary',
    title: 'Plan complex Itineraries',
    text: 'With multiple stops & timing',
    to: '/app/articles',
  },
  {
    id: 'article',
    title: 'Save useful Articles',
    text: 'Keep your favourite locations',
    to: '/app/articles',
  },
];
